import React, { Component } from 'react';
class AutoTransferEn extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  The Auto Transfer function is a function which automatically transfers the exceed amount to another wallet when the specified coin in the specified wallet exceed the set quantity.
                  For example, you can set up as a wallet receive coin paymens from customers to prevent excessive wallet balances and increase security.
                </div>
                <div className="example">
                  <p>Example:</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>① Set Auto Transfer function in the “wallet receiving coin payments from customer”</span>
                        <span>Specified coin：RIA</span>
                        <span>Specified coin amount：500,000RIA</span>
                        <span>Destination wallet: “Customer payment coin management wallet”</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② Coins will be sent from the customer to the wallet “wallet receiving coin payments from customer”. If the balance in “wallet receiving coin payment from customer” exceeds the specified quantity, excess coins will be automatically transferred to “Customer payment coin management wallet”.</span>
                      </div>
                    </li>
                  </ul>
                  <div class="img">
                    <img src="/images/auto-transfer-des-en.png" alt="Auto Transfer Des" />
                  </div>
                </div>
              </section>
              <hr />
              <section className="guide">
                <h3><b>How to set up the Auto Transfer function</b></h3>
                <ul className="step-guide decimal">
                  <li>Login to account and set from Menu’s Auto Transfer page</li>
                  <li>
                    <div className="text">
                      <span>Click Setup Auto Transfer button</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>In the <b>Name</b> field, enter a description of the Auto Transfer you want to set</span>
                      <span>For <b>Source Wallet</b>, please select the wallet you want to set the Auto Transfer function</span>
                      <span>In <b>Amount</b>, enter the maximum amount of balance held by Soure Wallet</span>
                      <span>Example: If Amount is set to 100,000, the Auto Transfer function will be actived if you hold more than 100,000 coins in that wallet, and the excess amount will be automatically transferred to the specified wallet.</span>
                      <span>Select the coin type in <b>Asset</b></span>
                      <span>Click NEXT button</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s2.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>Next, set the destination wallet for coins when the Auto Transfer function is actived.</span>
                      <span>If you want to set up a wallet in the same account, select from “Select destination from your wallets”.</span>
                      <span>If you want to set up a wallet in another account, please enter the wallet address directly in the “Enter the destination” field.</span>
                      <span>Check the wallet address you entered and click NEXT button.</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s3.png" alt="Auto Transfer S3" />
                    </div>
                    <div className="text highlight">
                      <span>Notices:</span>
                      <span>For Destination wallet, please set a wallet that does not require Tag to be specified when receiving coins. For example, if you set the wallet address of the exchange that requires Tag specification to Destination Wallet, the transfer process itself of Auto Transfer will be performed but please be careful because it may become an unknown deposit on the receiving side. </span>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>On the next screen, you can check the flow of the set Auto Transfer function in the diagram.</span>
                      <span>Check and click NEXT button </span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s4.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>The final confirmation screen will be displayed. Confirm it and click CONFIRM button. </span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s5.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>Enter your OP password and Google TFA and complete. </span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s6.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>Auto Transfer setting information can be checked for each wallet.</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s7.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferEn;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-en.jsx